import type { JSX } from "react";

import logo from "#src/images/logo.header.png";

/** @public export is necessary for TS; public is necessary for knip */
export interface Props {
  alt?: string;
  src?: string;
}

const Logo = (props: Props): JSX.Element => {
  const { alt = "Citrine Informatics", src = logo } = props;
  return <img src={src} alt={alt} />;
};

export default Logo;
